"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

const Hero1RightColumnDynamic = dynamic(
  () =>
    import(
      "@/components/pro-blocks/landing-page/hero-sections/hero-1-right-column"
    ).then((mod) => mod.Hero1RightColumn),
  {
    ssr: false,
  },
);

export function Hero1RightColumnClient(
  props: ComponentProps<typeof Hero1RightColumnDynamic>,
) {
  return <Hero1RightColumnDynamic {...props} />;
}
